<template>
  <div class="sub-page">
    <EventTeamSwiper />
    <VolleyballMatchTabbar @setComponent="setComponent" />
    <component :is="component" :componentName="component"></component>
  </div>
</template>

<script>
import VolleyballMatchTabbar from './components/VolleyballMatchTabbar.vue'
import EventTeamSwiper from '@comm/components/match/components/EventTeamSwiper.vue'
import VolleyballSchedule from './components/VolleyballSchedule.vue'
import VolleyballRank from './components/VolleyballRank.vue'
import VolleyballTeam from './components/VolleyballTeam.vue'
import VolleyballPlayer from './components/VolleyballPlayer.vue'
import VolleyballInfo from './components/VolleyballInfo.vue'
import VolleyballNotice from './components/VolleyballNotice.vue'
import MatchVolleyballSchedule from '@comm/components/MatchGame.vue'
export default {
  props: {},
  components: {
    EventTeamSwiper,
    VolleyballMatchTabbar,
    VolleyballSchedule,
    VolleyballRank,
    VolleyballTeam,
    VolleyballPlayer,
    VolleyballInfo,
    VolleyballNotice,
    MatchVolleyballSchedule,
  },
  data() {
    return {
      component: 'VolleyballInfo',
    }
  },
  mounted() {},
  methods: {
    setComponent(component) {
      this.component = component
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/VolleyBallHome.vue